(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './ktor-ktor-utils.js', './ktor-ktor-client-core.js', './ktor-ktor-http.js', './ktor-ktor-serialization.js', './ktor-ktor-io.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./ktor-ktor-utils.js'), require('./ktor-ktor-client-core.js'), require('./ktor-ktor-http.js'), require('./ktor-ktor-serialization.js'), require('./ktor-ktor-io.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-client-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-client-core' was not found. Please, check whether 'ktor-ktor-client-core' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-serialization'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-serialization' was not found. Please, check whether 'ktor-ktor-serialization' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    if (typeof this['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-content-negotiation'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-client-content-negotiation'.");
    }
    root['ktor-ktor-client-content-negotiation'] = factory(typeof this['ktor-ktor-client-content-negotiation'] === 'undefined' ? {} : this['ktor-ktor-client-content-negotiation'], this['kotlin-kotlin-stdlib'], this['ktor-ktor-utils'], this['ktor-ktor-client-core'], this['ktor-ktor-http'], this['ktor-ktor-serialization'], this['ktor-ktor-io']);
  }
}(this, function (_, kotlin_kotlin, kotlin_io_ktor_ktor_utils, kotlin_io_ktor_ktor_client_core, kotlin_io_ktor_ktor_http, kotlin_io_ktor_ktor_serialization, kotlin_io_ktor_ktor_io) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.fa;
  var classMeta = kotlin_kotlin.$_$.z8;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var CoroutineImpl = kotlin_kotlin.$_$.n8;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var PipelineContext = kotlin_io_ktor_ktor_utils.$_$.g;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z7;
  var HttpResponseContainer = kotlin_io_ktor_ktor_client_core.$_$.k;
  var contentType = kotlin_io_ktor_ktor_http.$_$.a1;
  var suitableCharset = kotlin_io_ktor_ktor_serialization.$_$.f;
  var plus = kotlin_kotlin.$_$.z6;
  var toMutableSet = kotlin_kotlin.$_$.s7;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var register$default = kotlin_io_ktor_ktor_serialization.$_$.b;
  var Configuration = kotlin_io_ktor_ktor_serialization.$_$.c;
  var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.l;
  var Phases_getInstance = kotlin_io_ktor_ktor_client_core.$_$.c;
  var Phases_getInstance_0 = kotlin_io_ktor_ktor_client_core.$_$.d;
  var HttpClientPlugin = kotlin_io_ktor_ktor_client_core.$_$.f;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var toString = kotlin_kotlin.$_$.ka;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
  var accept = kotlin_io_ktor_ktor_client_core.$_$.h;
  var Collection = kotlin_kotlin.$_$.v4;
  var isInterface = kotlin_kotlin.$_$.t9;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.o;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var contentType_0 = kotlin_io_ktor_ktor_http.$_$.z;
  var EmptyContent_getInstance = kotlin_io_ktor_ktor_client_core.$_$.e;
  var Unit = kotlin_kotlin.$_$.vd;
  var charset = kotlin_io_ktor_ktor_http.$_$.x;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.f;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var equals = kotlin_kotlin.$_$.c9;
  var joinToString = kotlin_kotlin.$_$.n6;
  var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.f1;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.k;
  var deserialize = kotlin_io_ktor_ktor_serialization.$_$.a;
  var Exception = kotlin_kotlin.$_$.bd;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h1;
  var captureStack = kotlin_kotlin.$_$.t8;
  var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.f;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.k4;
  var HttpStatusCode = kotlin_io_ktor_ktor_http.$_$.r;
  var getKClass = kotlin_kotlin.$_$.f;
  var setOf = kotlin_kotlin.$_$.h7;
  var endsWith = kotlin_kotlin.$_$.db;
  var startsWith = kotlin_kotlin.$_$.xb;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.w;
  //endregion
  //region block: pre-declaration
  setMetadataFor(ConverterRegistration, 'ConverterRegistration', classMeta);
  setMetadataFor(ContentNegotiation$Config$defaultMatcher$1, VOID, classMeta);
  setMetadataFor(ContentNegotiation$Plugin$install$slambda, 'ContentNegotiation$Plugin$install$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [2]);
  setMetadataFor(ContentNegotiation$Plugin$install$slambda_1, 'ContentNegotiation$Plugin$install$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [2]);
  setMetadataFor(Config, 'Config', classMeta, VOID, [Configuration], Config);
  setMetadataFor(Plugin, 'Plugin', objectMeta, VOID, [HttpClientPlugin]);
  setMetadataFor($convertRequestCOROUTINE$0, '$convertRequestCOROUTINE$0', classMeta, CoroutineImpl);
  setMetadataFor($convertResponseCOROUTINE$1, '$convertResponseCOROUTINE$1', classMeta, CoroutineImpl);
  setMetadataFor(ContentNegotiation, 'ContentNegotiation', classMeta, VOID, VOID, VOID, VOID, VOID, [2, 5]);
  setMetadataFor(ContentConverterException, 'ContentConverterException', classMeta, Exception);
  setMetadataFor(JsonContentTypeMatcher, 'JsonContentTypeMatcher', objectMeta);
  //endregion
  function get_LOGGER() {
    _init_properties_ContentNegotiation_kt__o183go();
    return LOGGER;
  }
  var LOGGER;
  function get_DefaultCommonIgnoredTypes() {
    _init_properties_ContentNegotiation_kt__o183go();
    return DefaultCommonIgnoredTypes;
  }
  var DefaultCommonIgnoredTypes;
  function ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher) {
    this.s54_1 = converter;
    this.t54_1 = contentTypeToSend;
    this.u54_1 = contentTypeMatcher;
  }
  function defaultMatcher($this, pattern) {
    return new ContentNegotiation$Config$defaultMatcher$1(pattern);
  }
  function ContentNegotiation$Config$defaultMatcher$1($pattern) {
    this.v54_1 = $pattern;
  }
  protoOf(ContentNegotiation$Config$defaultMatcher$1).w54 = function (contentType) {
    return contentType.a3t(this.v54_1);
  };
  function ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation) {
    this.f55_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$Plugin$install$slambda).l47 = function ($this$intercept, it, $completion) {
    var tmp = this.m47($this$intercept, it, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).hg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.l47(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 3;
            this.la_1 = 1;
            suspendResult = this.f55_1.m55(this.g55_1.j3q_1, this.g55_1.m3p(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.i55_1 = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (this.i55_1 == null) {
              return Unit_instance;
            } else {
              tmp_1 = this.i55_1;
            }

            tmp_0.j55_1 = tmp_1;
            this.la_1 = 2;
            suspendResult = this.g55_1.n3p(this.j55_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 3) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda).m47 = function ($this$intercept, it, completion) {
    var i = new ContentNegotiation$Plugin$install$slambda(this.f55_1, completion);
    i.g55_1 = $this$intercept;
    i.h55_1 = it;
    return i;
  };
  function ContentNegotiation$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new ContentNegotiation$Plugin$install$slambda($plugin, resultContinuation);
    var l = function ($this$intercept, it, $completion) {
      return i.l47($this$intercept, it, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation) {
    this.v55_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ContentNegotiation$Plugin$install$slambda_1).f48 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
    var tmp = this.g48($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).hg = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.f48(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 3;
            this.y55_1 = this.x55_1.md();
            this.z55_1 = this.x55_1.nd();
            var tmp_0 = this;
            var tmp0_elvis_lhs = contentType(this.w55_1.j3q_1.s47());
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              this.w55_1;
              get_LOGGER().g3r('Response doesn\'t have "Content-Type" header, skipping ContentNegotiation plugin');
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.a56_1 = tmp_1;
            this.b56_1 = suitableCharset(this.w55_1.j3q_1.b4b().i3x());
            this.la_1 = 1;
            suspendResult = this.v55_1.f56(this.w55_1.j3q_1.b4b().v21(), this.y55_1, this.z55_1, this.a56_1, this.b56_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.c56_1 = suspendResult;
            var tmp_2 = this;
            var tmp_3;
            if (this.c56_1 == null) {
              return Unit_instance;
            } else {
              tmp_3 = this.c56_1;
            }

            tmp_2.d56_1 = tmp_3;
            this.e56_1 = new HttpResponseContainer(this.y55_1, this.d56_1);
            this.la_1 = 2;
            suspendResult = this.w55_1.n3p(this.e56_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 3) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  protoOf(ContentNegotiation$Plugin$install$slambda_1).g48 = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, completion) {
    var i = new ContentNegotiation$Plugin$install$slambda_1(this.v55_1, completion);
    i.w55_1 = $this$intercept;
    i.x55_1 = _name_for_destructuring_parameter_0__wldtmu;
    return i;
  };
  function ContentNegotiation$Plugin$install$slambda_2($plugin, resultContinuation) {
    var i = new ContentNegotiation$Plugin$install$slambda_1($plugin, resultContinuation);
    var l = function ($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion) {
      return i.f48($this$intercept, _name_for_destructuring_parameter_0__wldtmu, $completion);
    };
    l.$arity = 2;
    return l;
  }
  function Config() {
    this.g56_1 = toMutableSet(plus(get_DefaultIgnoredTypes(), get_DefaultCommonIgnoredTypes()));
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.h56_1 = ArrayList_init_$Create$();
  }
  protoOf(Config).z43 = function (contentType, converter, configuration) {
    var matcher = contentType.equals(Application_getInstance().t3r_1) ? JsonContentTypeMatcher_instance : defaultMatcher(this, contentType);
    this.i56(contentType, converter, matcher, configuration);
  };
  protoOf(Config).i56 = function (contentTypeToSend, converter, contentTypeMatcher, configuration) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    configuration(converter);
    var registration = new ConverterRegistration(converter, contentTypeToSend, contentTypeMatcher);
    this.h56_1.r(registration);
  };
  function Plugin() {
    Plugin_instance = this;
    this.j56_1 = new AttributeKey('ContentNegotiation');
  }
  protoOf(Plugin).e2 = function () {
    return this.j56_1;
  };
  protoOf(Plugin).k56 = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var config = this_0;
    return new ContentNegotiation(config.h56_1, config.g56_1);
  };
  protoOf(Plugin).w49 = function (block) {
    return this.k56(block);
  };
  protoOf(Plugin).l56 = function (plugin, scope) {
    var tmp = Phases_getInstance().x4f_1;
    scope.r46_1.n3q(tmp, ContentNegotiation$Plugin$install$slambda_0(plugin, null));
    var tmp_0 = Phases_getInstance_0().r49_1;
    scope.s46_1.n3q(tmp_0, ContentNegotiation$Plugin$install$slambda_2(plugin, null));
  };
  protoOf(Plugin).x49 = function (plugin, scope) {
    return this.l56(plugin instanceof ContentNegotiation ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance;
  function Plugin_getInstance() {
    if (Plugin_instance == null)
      new Plugin();
    return Plugin_instance;
  }
  function ContentNegotiation$convertRequest$lambda(it) {
    return toString(it.s54_1);
  }
  function $convertRequestCOROUTINE$0(_this__u8e3s4, request, body, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.u56_1 = _this__u8e3s4;
    this.v56_1 = request;
    this.w56_1 = body;
  }
  protoOf($convertRequestCOROUTINE$0).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 7;
            var tmp0_iterator = this.u56_1.k55_1.u();
            while (tmp0_iterator.v()) {
              var element = tmp0_iterator.w();
              l$ret$1: do {
                get_LOGGER().g3r('Adding Accept=' + element.t54_1.w3s_1 + ' header for ' + this.v56_1.r48_1);
                if (this.v56_1.t48_1.s3n(HttpHeaders_getInstance().f3t_1, element.t54_1.toString())) {
                  break l$ret$1;
                }
                accept(this.v56_1, element.t54_1);
              }
               while (false);
            }

            var tmp_0;
            var tmp_1 = this.w56_1;
            if (tmp_1 instanceof OutgoingContent) {
              tmp_0 = true;
            } else {
              var tmp$ret$2;
              l$ret$3: do {
                var this_0 = this.u56_1.l55_1;
                var tmp_2;
                if (isInterface(this_0, Collection)) {
                  tmp_2 = this_0.b1();
                } else {
                  tmp_2 = false;
                }
                if (tmp_2) {
                  tmp$ret$2 = false;
                  break l$ret$3;
                }
                var tmp0_iterator_0 = this_0.u();
                while (tmp0_iterator_0.v()) {
                  var element_0 = tmp0_iterator_0.w();
                  if (element_0.a6(this.w56_1)) {
                    tmp$ret$2 = true;
                    break l$ret$3;
                  }
                }
                tmp$ret$2 = false;
              }
               while (false);
              tmp_0 = tmp$ret$2;
            }

            if (tmp_0) {
              get_LOGGER().g3r('Body type ' + getKClassFromExpression(this.w56_1) + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.v56_1.r48_1 + '.'));
              return null;
            }

            var tmp_3 = this;
            var tmp0_elvis_lhs = contentType_0(this.v56_1);
            var tmp_4;
            if (tmp0_elvis_lhs == null) {
              this.u56_1;
              get_LOGGER().g3r("Request doesn't have Content-Type header. Skipping ContentNegotiation for " + this.v56_1.r48_1 + '.');
              return null;
            } else {
              tmp_4 = tmp0_elvis_lhs;
            }

            tmp_3.x56_1 = tmp_4;
            var tmp_5 = this.w56_1;
            if (tmp_5 instanceof Unit) {
              get_LOGGER().g3r('Sending empty body for ' + this.v56_1.r48_1);
              this.v56_1.t48_1.x3n(HttpHeaders_getInstance().x3t_1);
              return EmptyContent_getInstance();
            }

            var tmp_6 = this;
            var this_1 = this.u56_1.k55_1;
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator_1 = this_1.u();
            while (tmp0_iterator_1.v()) {
              var element_1 = tmp0_iterator_1.w();
              if (element_1.u54_1.w54(this.x56_1)) {
                destination.r(element_1);
              }
            }

            var tmp_7;
            if (!destination.b1()) {
              tmp_7 = destination;
            } else {
              tmp_7 = null;
            }

            var tmp1_elvis_lhs = tmp_7;
            var tmp_8;
            if (tmp1_elvis_lhs == null) {
              this.u56_1;
              get_LOGGER().g3r('None of the registered converters match request Content-Type=' + this.x56_1 + '. ' + ('Skipping ContentNegotiation for ' + this.v56_1.r48_1 + '.'));
              return null;
            } else {
              tmp_8 = tmp1_elvis_lhs;
            }

            tmp_6.y56_1 = tmp_8;
            if (this.v56_1.c4v() == null) {
              get_LOGGER().g3r('Request has unknown body type. Skipping ContentNegotiation for ' + this.v56_1.r48_1 + '.');
              return null;
            }

            this.v56_1.t48_1.x3n(HttpHeaders_getInstance().x3t_1);
            this.la_1 = 1;
            continue $sm;
          case 1:
            var tmp_9 = this;
            tmp_9.a57_1 = this.y56_1;
            this.b57_1 = this.a57_1.u();
            this.la_1 = 2;
            continue $sm;
          case 2:
            if (!this.b57_1.v()) {
              this.la_1 = 5;
              continue $sm;
            }

            this.c57_1 = this.b57_1.w();
            var tmp_10 = this;
            tmp_10.d57_1 = this.c57_1;
            this.la_1 = 3;
            var tmp0_elvis_lhs_0 = charset(this.x56_1);
            var tmp_11 = tmp0_elvis_lhs_0 == null ? Charsets_getInstance().y3h_1 : tmp0_elvis_lhs_0;
            var tmp_12 = ensureNotNull(this.v56_1.c4v());
            var this_2 = this.w56_1;
            var tmp_13;
            if (!equals(this_2, NullBody_instance)) {
              tmp_13 = this_2;
            } else {
              tmp_13 = null;
            }

            suspendResult = this.d57_1.s54_1.c44(this.x56_1, tmp_11, tmp_12, tmp_13, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var result = suspendResult;
            if (!(result == null)) {
              get_LOGGER().g3r('Converted request body using ' + this.d57_1.s54_1 + ' for ' + this.v56_1.r48_1);
            }

            var result_0 = result;
            if (!(result_0 == null)) {
              this.z56_1 = result_0;
              this.la_1 = 6;
              continue $sm;
            } else {
              this.la_1 = 4;
              continue $sm;
            }

          case 4:
            this.la_1 = 2;
            continue $sm;
          case 5:
            this.z56_1 = null;
            if (false) {
              this.la_1 = 1;
              continue $sm;
            }

            this.la_1 = 6;
            continue $sm;
          case 6:
            var tmp2_elvis_lhs = this.z56_1;
            var tmp_14;
            if (tmp2_elvis_lhs == null) {
              var tmp_15 = "Can't convert " + toString(this.w56_1) + ' with contentType ' + this.x56_1 + ' using converters ';
              throw new ContentConverterException(tmp_15 + joinToString(this.y56_1, VOID, VOID, VOID, VOID, VOID, ContentNegotiation$convertRequest$lambda));
            } else {
              tmp_14 = tmp2_elvis_lhs;
            }

            var serializedContent = tmp_14;
            return serializedContent;
          case 7:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 7) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  function $convertResponseCOROUTINE$1(_this__u8e3s4, requestUrl, info, body, responseContentType, charset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.m57_1 = _this__u8e3s4;
    this.n57_1 = requestUrl;
    this.o57_1 = info;
    this.p57_1 = body;
    this.q57_1 = responseContentType;
    this.r57_1 = charset;
  }
  protoOf($convertResponseCOROUTINE$1).ib = function () {
    var suspendResult = this.na_1;
    $sm: do
      try {
        var tmp = this.la_1;
        switch (tmp) {
          case 0:
            this.ma_1 = 2;
            var tmp_0 = this.p57_1;
            if (!isInterface(tmp_0, ByteReadChannel)) {
              get_LOGGER().g3r('Response body is already transformed. Skipping ContentNegotiation for ' + this.n57_1 + '.');
              return null;
            }

            if (this.m57_1.l55_1.z(this.o57_1.b3r_1)) {
              get_LOGGER().g3r('Response body type ' + this.o57_1.b3r_1 + ' is in ignored types. ' + ('Skipping ContentNegotiation for ' + this.n57_1 + '.'));
              return null;
            }

            var tmp_1 = this;
            var this_0 = this.m57_1.k55_1;
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator = this_0.u();
            while (tmp0_iterator.v()) {
              var element = tmp0_iterator.w();
              if (element.u54_1.w54(this.q57_1)) {
                destination.r(element);
              }
            }

            var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(destination, 10));
            var tmp0_iterator_0 = destination.u();
            while (tmp0_iterator_0.v()) {
              var item = tmp0_iterator_0.w();
              destination_0.r(item.s54_1);
            }

            var tmp_2;
            if (!destination_0.b1()) {
              tmp_2 = destination_0;
            } else {
              tmp_2 = null;
            }

            var tmp0_elvis_lhs = tmp_2;
            var tmp_3;
            if (tmp0_elvis_lhs == null) {
              this.m57_1;
              get_LOGGER().g3r('None of the registered converters match response with Content-Type=' + this.q57_1 + '. ' + ('Skipping ContentNegotiation for ' + this.n57_1 + '.'));
              return null;
            } else {
              tmp_3 = tmp0_elvis_lhs;
            }

            tmp_1.s57_1 = tmp_3;
            this.la_1 = 1;
            suspendResult = deserialize(this.s57_1, this.p57_1, this.o57_1, this.r57_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!isInterface(result, ByteReadChannel)) {
              get_LOGGER().g3r('Response body was converted to ' + getKClassFromExpression(result) + ' for ' + this.n57_1 + '.');
            }

            return result;
          case 2:
            throw this.oa_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.ma_1 === 2) {
          throw e;
        } else {
          this.la_1 = this.ma_1;
          this.oa_1 = e;
        }
      }
     while (true);
  };
  function ContentNegotiation(registrations, ignoredTypes) {
    Plugin_getInstance();
    this.k55_1 = registrations;
    this.l55_1 = ignoredTypes;
  }
  protoOf(ContentNegotiation).m55 = function (request, body, $completion) {
    var tmp = new $convertRequestCOROUTINE$0(this, request, body, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  protoOf(ContentNegotiation).f56 = function (requestUrl, info, body, responseContentType, charset, $completion) {
    var tmp = new $convertResponseCOROUTINE$1(this, requestUrl, info, body, responseContentType, charset, $completion);
    tmp.na_1 = Unit_instance;
    tmp.oa_1 = null;
    return tmp.ib();
  };
  function ContentConverterException(message) {
    Exception_init_$Init$(message, this);
    captureStack(this, ContentConverterException);
  }
  var properties_initialized_ContentNegotiation_kt_1ayduy;
  function _init_properties_ContentNegotiation_kt__o183go() {
    if (!properties_initialized_ContentNegotiation_kt_1ayduy) {
      properties_initialized_ContentNegotiation_kt_1ayduy = true;
      LOGGER = KtorSimpleLogger('io.ktor.client.plugins.contentnegotiation.ContentNegotiation');
      DefaultCommonIgnoredTypes = setOf([PrimitiveClasses_getInstance().i7(), PrimitiveClasses_getInstance().e7(), getKClass(HttpStatusCode), getKClass(ByteReadChannel), getKClass(OutgoingContent)]);
    }
  }
  function JsonContentTypeMatcher() {
  }
  protoOf(JsonContentTypeMatcher).w54 = function (contentType) {
    if (contentType.a3t(Application_getInstance().t3r_1)) {
      return true;
    }
    var value = contentType.z3s().toString();
    return startsWith(value, 'application/') ? endsWith(value, '+json') : false;
  };
  var JsonContentTypeMatcher_instance;
  function JsonContentTypeMatcher_getInstance() {
    return JsonContentTypeMatcher_instance;
  }
  function get_DefaultIgnoredTypes() {
    _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1();
    return DefaultIgnoredTypes;
  }
  var DefaultIgnoredTypes;
  var properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt;
  function _init_properties_DefaultIgnoredTypesJs_kt__rjtdk1() {
    if (!properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt) {
      properties_initialized_DefaultIgnoredTypesJs_kt_65g2xt = true;
      // Inline function 'kotlin.collections.mutableSetOf' call
      DefaultIgnoredTypes = LinkedHashSet_init_$Create$();
    }
  }
  //region block: post-declaration
  protoOf(Config).a44 = register$default;
  //endregion
  //region block: init
  JsonContentTypeMatcher_instance = new JsonContentTypeMatcher();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Plugin_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-client-content-negotiation.js.map
